function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import AttributeService from '@/apps/attributes/services/attributes_service';
import AttrFlagsService from '@/apps/attributes/services/attr_flags_service';
import userSettingsService from '@/apps/data-platform/services/security/user_settings_service';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import DomainService from '@/apps/data-platform/services/master_data/domain_service';
export default {
  setAttributes: function setAttributes(context, query) {
    context.commit('setAttributes', query);
  },
  getCompanyAbrevs: function getCompanyAbrevs(context) {
    return AttributeService.getCompanyAbrevs().then(function (response) {
      context.commit('setCompanyAbrevs', response.data.itc_company_abrev);
    });
  },
  getLabelCatalog: function getLabelCatalog(context) {
    return AttributeService.getLabelCatalog().then(function (response) {
      context.commit('setLabelCatalog', response.data);
    });
  },
  getStatusLogTypes: function getStatusLogTypes(context) {
    return AttributeService.getStatusLogTypes().then(function (response) {
      context.commit('setStatusLogType', response.data);
    });
  },
  getAttributeSourcesCatalog: function getAttributeSourcesCatalog(context) {
    return AttributeService.getAttributeSourcesCatalog().then(function (response) {
      context.commit('setAttributeSourcesCatalog', response.data && response.data.attribute_source_id);
    });
  },
  getSolicitudeTypes: function getSolicitudeTypes(context) {
    return AttributeService.getSolicitudeTypes().then(function (response) {
      context.commit('setSolicitudeTypes', response.data && response.data.solicitude_type_id);
    });
  },
  getBusinessUserServiceAccounts: function getBusinessUserServiceAccounts(context, companyCode) {
    return AttributeService.getBusinessUserServiceAccounts(companyCode).then(function (response) {
      context.commit('setBusinessUserServiceAccounts', response.data && Object.values(response.data.business_users));
    });
  },
  getUserNotifications: function getUserNotifications(context) {
    var email = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!email) {
      email = window.userInfo.email;
    }
    return userSettingsService.getUserNotifications(email).then(function (response) {
      console.log('from store attributes');
      context.commit('setUserNotificationsnew', response.data);
    });
  },
  getCompanyFlags: function getCompanyFlags(context, data) {
    AttrFlagsService.getCompanyFlags(window.userInfo.companyCode).then(function (response) {
      if (response.success) {
        context.commit('setFlagCustomExpirationSbx', response.data.flag_custom_expiration_sbx === '1');
      } else {
        context.commit('setFlagCustomExpirationSbx', false);
      }
    });
  },
  getAttributeGroupsByOrg: function () {
    var _getAttributeGroupsByOrg = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, companyCode) {
      var commit, state, response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit, state = _ref.state;
            if (companyCode) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            if (!state.groupsByOrgCache[companyCode]) {
              _context.n = 2;
              break;
            }
            commit('SET_GROUPS_BY_ORG', state.groupsByOrgCache[companyCode]);
            return _context.a(2);
          case 2:
            _context.p = 2;
            _context.n = 3;
            return UseCasesService.getAttributeGroupsByOrganization(companyCode);
          case 3:
            response = _context.v;
            commit('SET_GROUPS_BY_ORG', response.data || {
              company_code: '',
              company_name: '',
              groups: []
            });
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            console.error('[getAttributeGroupsByOrg]', _t);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4]]);
    }));
    function getAttributeGroupsByOrg(_x, _x2) {
      return _getAttributeGroupsByOrg.apply(this, arguments);
    }
    return getAttributeGroupsByOrg;
  }(),
  getOrganizations: function () {
    var _getOrganizations = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref2) {
      var commit, response, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref2.commit;
            _context2.p = 1;
            _context2.n = 2;
            return DomainService.getOrganizationsDetail({}, {
              lock: false
            });
          case 2:
            response = _context2.v;
            commit('setOrganizations', response.data);
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            console.error('[getOrganizations]', _t2);
            throw _t2;
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    function getOrganizations(_x3) {
      return _getOrganizations.apply(this, arguments);
    }
    return getOrganizations;
  }(),
  loadOrgGroupCounts: function () {
    var _loadOrgGroupCounts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref3, codes) {
      var commit, state, entries;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            commit = _ref3.commit, state = _ref3.state;
            if (!(!Array.isArray(codes) || codes.length === 0)) {
              _context4.n = 1;
              break;
            }
            commit('setOrgGroupCounts', {});
            return _context4.a(2);
          case 1:
            _context4.n = 2;
            return Promise.all(codes.map(/*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(code) {
                var cachedGroups, res, data, groups, _t3;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.p = _context3.n) {
                    case 0:
                      if (!(state.orgGroupCounts[code] !== undefined)) {
                        _context3.n = 1;
                        break;
                      }
                      return _context3.a(2, [code, state.orgGroupCounts[code]]);
                    case 1:
                      if (!state.groupsByOrgCache[code]) {
                        _context3.n = 2;
                        break;
                      }
                      cachedGroups = state.groupsByOrgCache[code].groups || [];
                      return _context3.a(2, [code, cachedGroups.filter(function (g) {
                        return g.alias;
                      }).length]);
                    case 2:
                      _context3.p = 2;
                      _context3.n = 3;
                      return UseCasesService.getAttributeGroupsByOrganization(code);
                    case 3:
                      res = _context3.v;
                      data = res && res.data || {
                        company_code: code,
                        groups: []
                      };
                      commit('SET_GROUPS_BY_ORG_CACHE', data);
                      groups = data.groups || [];
                      return _context3.a(2, [code, groups.filter(function (g) {
                        return g.alias;
                      }).length]);
                    case 4:
                      _context3.p = 4;
                      _t3 = _context3.v;
                      console.error('[loadOrgGroupCounts]', code, _t3);
                      return _context3.a(2, [code, 0]);
                  }
                }, _callee3, null, [[2, 4]]);
              }));
              return function (_x6) {
                return _ref4.apply(this, arguments);
              };
            }()));
          case 2:
            entries = _context4.v;
            commit('setOrgGroupCounts', Object.fromEntries(entries));
          case 3:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    function loadOrgGroupCounts(_x4, _x5) {
      return _loadOrgGroupCounts.apply(this, arguments);
    }
    return loadOrgGroupCounts;
  }()
};